import { useSuspenseQuery } from "@tanstack/react-query";

import { organizationsQueryOptions } from "src/queries/organizations";

import { AccountMenuContent } from "./AccountMenuContent";

interface AccountMenuWithOrganizationsProps {
  canCreateOrganizations: boolean;
  sidebar?: boolean;
}

export function AccountMenuWithOrganizations(
  props: AccountMenuWithOrganizationsProps,
) {
  const organizationsQuery = useSuspenseQuery(organizationsQueryOptions());

  return (
    <AccountMenuContent
      canCreateOrganizations={props.canCreateOrganizations}
      organizations={organizationsQuery.data}
      sidebar={props.sidebar}
    />
  );
}
